// src/ThemeContext.js
import React, { createContext, useState, useEffect, useMemo } from "react";

// Создаём контекст темы с начальными значениями
export const ThemeContext = createContext({
  darkMode: false,
  toggleTheme: () => {},
});

// Создаём провайдер темы
export const CustomThemeProvider = ({ children }) => {
  const [darkMode, setDarkMode] = useState(
    () => localStorage.getItem("darkMode") === "true"
  );

  useEffect(() => {
    localStorage.setItem("darkMode", darkMode);
  }, [darkMode]);

  const toggleTheme = () => {
    setDarkMode((prevMode) => !prevMode);
  };

  // Мемоизируем значения контекста для оптимизации
  const contextValue = useMemo(() => ({ darkMode, toggleTheme }), [darkMode]);

  return (
    <ThemeContext.Provider value={contextValue}>
      {children}
    </ThemeContext.Provider>
  );
};
